<template>
  <b-row class="h-100">
    <b-colxx xxs="12" md=6  class="mx-auto my-auto">
      <b-card class="auth-card" no-body>
          <div class="form-side w-100">
            <div class="buttons display-table">
              <!-- <b-button class="mb-1 display-table-cell w-100" @click="changeType('docteur')" :variant="loginType=='docteur'?'info default':'light default'">Docteur</b-button>
              <b-button class="mb-1 display-table-cell w-100" @click="changeType('assistant')" :variant="loginType=='assistant'?'info default':'light default'">Assistant</b-button> -->


            </div>
            <div class="mb-5 text-center">
              <img height="100" :src="require('@/assets/img/logo-black.png')">
            </div>
            <!-- <router-link tag="a" to="/"><span class="logo-single"/></router-link> -->
            <h6 class="mb-4">{{ $t('user.login-title')}}</h6>
            <b-form @submit.prevent="formSubmit">
              
              <label class="form-group has-float-label mb-4">
                <input type="email" class="form-control" v-model="email">
                <span>{{ $t('user.email') }}</span>
              </label>
              <label class="form-group has-float-label mb-4">
                <input type="password" class="form-control" v-model="password">
                <span>{{ $t('user.password') }}</span>
              </label>

              <b-form-group class="display-table" :label="'Je suis'">
                  <!-- <b-form-input v-model="newUser.gender" /> -->
                  <b-radio name="user" value="user" class="display-inline-flex" v-model="loginType">
                    Docteur
                  </b-radio>

                  <b-radio name="assistant" value="assistant" class="display-inline-flex" v-model="loginType">
                    Assistant
                  </b-radio>
              </b-form-group>

              <div class="d-flex justify-content-between align-items-center">
                  <b-button v-if="!loading" type="submit" variant="primary" size="lg" class="btn-shadow w-100" :disabled="false">{{ 'Connexion'}}</b-button>
                  <b-button v-else disabled variant="primary" size="lg" class="btn-shadow w-100">
                    <div class="span w-100">
                      <div class="typing_loader"></div>
                    </div>
                  </b-button>

                  
              </div>
          </b-form>
        </div>
      </b-card>
    </b-colxx>
  </b-row>
</template>
<script>
// import Vue from "vue";
// import ElementUI from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
// Vue.use(ElementUI);
import { mapGetters, mapActions } from 'vuex'
import { apiUrl } from "@/constants/config";
export default {
  data () {
    return {
      email: '',
      password: '',
      loginType:'user',
      loading:false
    }
  },
  computed: {
  },
  methods: {
    changeType(type){
      this.loginType = type
    },
    loginError (val) {
      if (val != null) {
        this.$notify('error filled', '', val, { duration: 5000, permanent: false })
      }
    },
    formSubmit () {
      this.login({ email: this.email, password: this.password })
    },
    async login(data){
      this.loading = true
      let endpoint = `${apiUrl}/${this.loginType}s/login`

      let user = await this.sendRequest('post',endpoint,data)
      if(user && user.data){
        if(user.data.user){
          user.data.user.permission = this.loginType == "user" ? 'docteur' : 'assistant'
          this.$store.state.currentUser = user.data.user
          localStorage.setItem('user', JSON.stringify(user.data.user))
          this.setToken(user.data.access_token)
          this.$notify('success filled', '', 'Bienvenue.', { duration: 5000, permanent: false })
          this.$router.push({name:"default"})
        }
        else{
          this.loginError(user.data.message)
        }
      }
      this.loading = false
    }
  },
  watch: {
    
  }
}
</script>
<style lang="scss">
  .buttons{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: max-content;
  }
  .typing_loader{
    width: 6px;
    height: 6px;
    border-radius: 50%;
    -webkit-animation: typing 1s linear infinite alternate;
       -moz-animation: Typing 1s linear infinite alternate;
            animation: typing 1s linear infinite alternate;
    margin: 10px auto; /* Not necessary- its only for layouting*/  
    position: relative;
    left: -12px;
  }
  @-webkit-keyframes typing{
      0%{
          background-color: rgba(255,255,255, 1);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                      24px 0px 0px 0px rgba(255,255,255,0.2);
        }
      25%{ 
          background-color: rgba(255,255,255, 0.4);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,2), 
                      24px 0px 0px 0px rgba(255,255,255,0.2);
      }
      75%{ background-color: rgba(255,255,255, 0.4);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                      24px 0px 0px 0px rgba(255,255,255,1);
        }
  }

  @-moz-keyframes typing{
    0%{
          background-color: rgba(255,255,255, 1);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                      24px 0px 0px 0px rgba(255,255,255,0.2);
        }
      25%{ 
          background-color: rgba(255,255,255, 0.4);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,2), 
                      24px 0px 0px 0px rgba(255,255,255,0.2);
      }
      75%{ background-color: rgba(255,255,255, 0.4);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                      24px 0px 0px 0px rgba(255,255,255,1);
        }
  }

  @keyframes typing{
    0%{
          background-color: rgba(255,255,255, 1);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                      24px 0px 0px 0px rgba(255,255,255,0.2);
        }
      25%{ 
          background-color: rgba(255,255,255, 0.4);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,2), 
                      24px 0px 0px 0px rgba(255,255,255,0.2);
      }
      75%{ background-color: rgba(255,255,255, 0.4);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                      24px 0px 0px 0px rgba(255,255,255,1);
        }
  }
</style>